{
  "version": 1,
  "asset_id": "bdaabc31-08c9-4d8b-a1d0-ae6f9d3dc09c",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/bdaabc31-08c9-4d8b-a1d0-ae6f9d3dc09c/thumb-entities.webp",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/bdaabc31-08c9-4d8b-a1d0-ae6f9d3dc09c/thumb-entities.webp",
  "original_filename": "thumb-entities.webp",
  "size": 172458,
  "content_type": "image/webp",
  "created_at": "2026-08-30T13:03:44Z"
}
